import React from 'react';

//components
import BasicTextInput from '../../../../../global/textInputs/BasicTextInput';
import BasicButton from '../../../../../global/buttons/BasicButton';

//interfaces
import { FormElementType, ValidationRules } from '../../../../interfaces/IFormElement';
import { IEditSubmitButton } from '../../../../interfaces/IFormBuilderButtons';



const EditSubmitButtonDetails = ({placeholderText, submitButtonText, setSubmitButtonText, onContinueClick, validationErrors, type}: IEditSubmitButton ) => {

    const titleIsInvalid = validationErrors?.includes(ValidationRules.TITLE_IS_REQUIRED);
    const hasValidationErrors = (validationErrors?.length ?? 0) >= 1;

    function showValidationError(label: string) {
        return hasValidationErrors || label.length >= 21
    }

    return (
        <div className={`form-element-edit-details-wrapper edit-submit-button-details ${showValidationError(submitButtonText) ? 'form-validation-errors' : ''}`}>
            <div className='header-panel'>
                <h3 className='header-label-text'>{submitButtonText}</h3>
                            
                <span className='element-type-text'>{`(${type})`}</span>
            </div>

            <BasicTextInput 
                className={"form-element-label-input"}
                labelText={`${type?.toUpperCase()}`} 
                placeholderText={placeholderText} 
                textString={submitButtonText} 
                setTextString={setSubmitButtonText}
                maxLength={21}
                autofocus 
            />
            {titleIsInvalid && <span className='error-text'>{type} text is required</span>}   
            {submitButtonText.length >= 21 &&  <span className="error-text">Please enter a maximum of 20 characters</span>}   

            <div className='button-panel'>
                <BasicButton
                    ariaLabel="Done"
                    className="thrive-navy-style full-width-continue-button"
                    content="Done"
                    onButtonClick={onContinueClick}
                    isClassicThriveStyle
                />
            </div>
        </div>
    );
};

export default EditSubmitButtonDetails